export const locale = {
  lang: 'es',
  full: {
    SUPPORT: 'Soporte',
    CONTACT: 'Contáctenos',
    WHY: '¿Por qué nosotros?'
  }
};
